// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".date-input input[type=number]{-moz-appearance:textfield}.date-input input::-webkit-inner-spin-button,.date-input input::-webkit-outer-spin-button{-webkit-appearance:none}", ""]);
// Exports
module.exports = exports;
